module.exports = __webpack_public_path__ + "static/media/ne.0c432227.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ne.svg
// module id = 207
// module chunks = 0